enum CidGender {
    FEMALE = 'FEMALE',
    MALE = 'MALE',
    BOTH = 'BOTH'
}

export default CidGender;
